<template>
    <div id="appRoot">
        <template v-if="!$route.meta.public">
            <v-app id="inspire" class="app">
                <app-toolbar class="app--toolbar"></app-toolbar>
                <app-drawer class="app--drawer"></app-drawer>
                <v-content>
                    <!-- Page Header -->
                    <!-- <page-header v-if="$route.meta.breadcrumb"></page-header> -->
                    <div class="page-wrapper">
                        <router-view></router-view>
                    </div>
                    <!-- App Footer -->
                    <!-- <v-footer height="auto" class="white pa-3 app--footer transparent">
                    <v-spacer></v-spacer>
                    <span class="caption">Vietmap Motrak Admin Tool v1.0</span>
                    <v-spacer></v-spacer>
                    </v-footer>-->
                </v-content>
                <!-- Go to top -->
                <!-- <app-fab></app-fab> -->
            </v-app>
        </template>
        <template v-else>
            <transition>
                <keep-alive>
                    <router-view></router-view>
                </keep-alive>
            </transition>
        </template>
        <v-snackbar :timeout="5000" bottom right :color="snackbar.color" v-model="snackbar.show">
            {{ snackbar.text }}
            <v-btn dark flat @click.native="snackbar.show = false" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
        <v-dialog v-model="loadingDialog" persistent hide-overlay width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    Đang tải dữ liệu
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import AppDrawer from '@/components/AppDrawer';
import AppToolbar from '@/components/AppToolbar';
import AppFab from '@/components/AppFab';
import PageHeader from '@/components/PageHeader';
import menu from '@/api/menu';
import ThemeSettings from '@/components/ThemeSettings';
import AppEvents from './event';
import * as Auth from '@/utils/auth';
import { mapActions, mapMutations } from 'vuex';

export default {
  components: {
    AppDrawer,
    AppToolbar,
    AppFab,
    PageHeader,
    ThemeSettings
  },
  data: () => ({
    expanded: true,
    rightDrawer: false,
    snackbar: {
      show: false,
      text: '',
      color: ''
    },
    loadingDialog: false
  }),
  created () {
    AppEvents.forEach(item => {
      this.$on(item.name, item.callback);
    });
    window.getApp = this;
    this.getAccessToken();
  },

  mounted () {
    window.onload = () => {
      this.getUser();
      if (
        this.$route.query.appId ||
        this.$route.query.accesstoken ||
        this.$route.query.refreshtoken ||
        this.$route.query.clientId
      ) {
        window.location.href = Auth.setURL(window.location.href);
      }
    };
  },

  methods: {
    openThemeSettings () {
      this.$vuetify.goTo(0);
      this.rightDrawer = !this.rightDrawer;
    },
    showMessage (text, type = 'success') {
      this.snackbar = {
        show: true,
        text: text,
        color: type === 'error' ? 'red' : 'green'
      };
    },
    showLoading (isShow) {
      this.loadingDialog = isShow;
    },

    ...mapActions(['GetProfile', 'logOut', 'getUserProfile', 'getUserInfo']),
    ...mapMutations([
      'SET_KEYWORD',
      'SET_TOKEN',
      'SET_REFRESH_TOKEN',
      'SET_CLIENT_ID'
    ]),

    getAccessToken () {
      let link = window.location.href;
      let accessToken = link
        .slice(link.indexOf('accesstoken'), link.indexOf('&refreshtoken'))
        .replace('accesstoken=', '');
      let refreshtoken = link
        .slice(link.indexOf('refreshtoken'), link.indexOf('&clientId'))
        .replace('refreshtoken=', '');
      if (accessToken && refreshtoken) {
        this.SET_TOKEN(accessToken);
        this.SET_REFRESH_TOKEN(refreshtoken);
      }
      if (link.indexOf('clientId') !== -1) {
        let clientId = link
          .slice(link.indexOf('clientId'), link.length)
          .replace('clientId=', '');
        if (clientId && clientId !== '/') this.SET_CLIENT_ID(clientId);
      }
    },

    async getUser () {
      let clientId = Auth.getClientId();
      if (!clientId) return;
      let res = await this.getUserInfo().catch(() => {
        return false;
      });
      if (res) this.user = res;
    }
  }
};
</script>

<style lang="stylus" scoped>
.page-wrapper {
    min-height: calc(100vh - 64px - 50px - 81px);
}

.transparent {
    background: none;
}

.left {
    float: left;
}

.right {
    float: right;
}

.clear {
    clear: both;
}

.no-wrap {
    white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/App.vue